import MapView from './MapView'

export default MapView
